mobileSize = 1200;
function placeCountdown() {
	if ($('body.homepage').hasClass('saffireMobileSize')) {
		$('.homepage #siteInfoBannerWidget').prependTo('.tier-two-inner');
	} else {
		$('.homepage #siteInfoBannerWidget').prependTo('.header-top-right');
	}
}

$(document).ready(function () {
    // Check Window Size
    const windowSize = $(window).width();
    if (windowSize < 1200) {
        $('body')
        .addClass('saffireMobileSize')
        .removeClass('saffireLargeSize');
    } if (windowSize > 1200) {
        $('body').removeClass('saffireMobileSize');
    }
    $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
    // General Message
    $('.generalmessage').prependTo('header');
    $(".tier-four .emailSignupText").html("get hendricks county 4-h fairgrounds updates");
    $(".standardMode  .tier-four .emailSignupText").html("get hendricks county 4-h fair updates");
    $(".tier-four .emailSubmitButton").html("subscribe");
    $(".footerItems1 a").removeClass("button");
  });

$(window).load(function () {
    $(".footerItems1 a").removeClass("button");
    // Weather Bug
    setInterval(function () {
        var str = $('#weatherBugDescription').text();
        var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
        if (!weatherBugSet && str != '') {
            $('#weatherBugWidget').addClass('weatherBugSet');
            var findSpace = str.lastIndexOf(' ');
            var stringLength = str.length;
            var res = str.substring(findSpace, stringLength);
            var start = str.substring(0, findSpace);
            $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
            $('#weatherBugWidget').css('visibility', 'visible');
        }
    }, 12);
     //Search Input text Reappeare
	var searchInput = $('.searchBox input');
	searchInput.val('Search');
	searchInput.on("click", function () {
		ClearDefaultText(this, 'Search');
	});
	searchInput.on("blur", function () {
		if ($.trim($(this).val()) == '') {
			$(this).val('Search');
		}
    });
      //Signup Input text Reappeare
    var mailInput = $('.tier-four .emailSignup input');
	mailInput.val('Email Address');
	mailInput.on("click", function () {
		ClearDefaultText(this, 'Email Address');
	});
	mailInput.on("blur", function () {
		if ($.trim($(this).val()) == '') {
			$(this).val('Email Address');
		}
    });
    $(".footerItems1 a").removeClass("button");
    $(".clickdown").on('click', function () {
        $('html, body').animate({
          'scrollTop': $(".tier-two").position().top
        });
      });
    $('.generalmessage').prependTo('header');
    $(".tier-four .emailSignupText").html("get hendricks county 4-h fairgrounds updates");
    $(".standardMode  .tier-four .emailSignupText").html("get hendricks county 4-h fair updates");
    $(".tier-four .emailSubmitButton").html("subscribe");
    $(".footerItems1 a").removeClass("button");
    if ($('body').hasClass('saffireMobileSize')) {
		$('#siteInfoBannerWidget').insertAfter('.header-bottom');
	} else {
		$('#siteInfoBannerWidget').prependTo('.header-top-right');
	}
    placeCountdown();
});
$(window).resize(function () {
    $(".footerItems1 a").removeClass("button");
   
    if ($('body').hasClass('saffireMobileSize')) {
		$('#siteInfoBannerWidget').insertAfter('.header-bottom');
	} else {
		$('#siteInfoBannerWidget').prependTo('.header-top-right');
    }
    placeCountdown();
});